import Input from '@merq/web-ui/dist/components/Input';
import { Button, FormControlLabel, Switch, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import IndexSelector from 'pages/IndexWizard/EquityIndexForm/widgets/IndexSelector';
import React, { useEffect } from 'react';
import useStore from 'store';
import { MuiColorInput } from 'mui-color-input';

const DOMAIN_URL = import.meta.env.VITE_DOMAIN_URL!;

const Demo = () => {
  const [indexName, setIndexName] = React.useState('MQ2Q0BQR');
  const [selectedIndex, setSelectedIndex] = React.useState(indexName);

  const [height, setHeight] = React.useState('500px');
  const [selectedHeight, setSelectedHeight] = React.useState(height);

  const [color1, setColor1] = React.useState('#7AFF8A');
  const [color2, setColor2] = React.useState('#24A1FF');

  const [legend, setLegend] = React.useState(true);
  const [selectedLegend, setSelectedLegend] = React.useState('');

  const [selectedColors, setSelectedColors] = React.useState(
    `${encodeURIComponent(color1)},${encodeURIComponent(color2)}`
  );

  const getIndices = useStore(state => state.getIndices);

  useEffect(() => {
    getIndices();
  }, []);

  const onSubmit = () => {
    setSelectedIndex(indexName);
    setSelectedHeight(height);
    setSelectedColors(`${encodeURIComponent(color1)},${encodeURIComponent(color2)}`);
    setSelectedLegend(legend ? '' : '&legend=false');
  };

  return (
    <>
      <Grid container spacing={2} mt={0} mb={2} pl={2} pr={2}>
        <Grid size={12}>
          <Typography variant="h5" color="textPrimary">
            Embedded Index Levels Chart Builder
          </Typography>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 12,
            lg: 5
          }}>
          <IndexSelector onChange={setIndexName} value={indexName} />
        </Grid>
        <Grid
          size={{
            xs: 6,
            sm: 4,
            md: 2.4,
            lg: 1.5
          }}>
          <MuiColorInput
            format="hex"
            classes={{ root: 'MuiInputPaper' }}
            value={color1}
            onChange={setColor1}
            label="Index Color"
            size={'normal' as any}
            fullWidth
            isAlphaHidden
            sx={{
              '& .MuiColorInput-Button': {
                height: '24px',
                minHeight: '24px',
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6,
            sm: 4,
            md: 2.4,
            lg: 1.5
          }}>
          <MuiColorInput
            format="hex"
            classes={{ root: 'MuiInputPaper' }}
            value={color2}
            onChange={setColor2}
            label="Benchmark Color"
            size={'normal' as any}
            fullWidth
            isAlphaHidden
            sx={{
              '& .MuiColorInput-Button': {
                height: '24px',
                minHeight: '24px',
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6,
            sm: 4,
            md: 2.4,
            lg: 1.5
          }}>
          <Input label="Height" variant="outlined" paper value={height} onChange={setHeight} />
        </Grid>
        <Grid
          size={{
            xs: 6,
            sm: 4,
            md: 2.4,
            lg: 1.5
          }}>
          <FormControlLabel
            control={
              <Switch checked={legend} onChange={e => setLegend(e.target.checked)} name="legend" />
            }
            label={
              <Typography variant="body1" color="textPrimary">
                Show Legend
              </Typography>
            }
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            sm: 4,
            md: 2.4,
            lg: 1
          }}>
          <Button variant="contained" sx={{ borderRadius: '5px' }} onClick={onSubmit} fullWidth>
            Try it out
          </Button>
        </Grid>
        <Grid sx={{ color: 'text.secondary' }} size={12}>
          <code style={{ wordWrap: 'break-word', color: 'inherit' }}>
            {`<iframe
              src="${DOMAIN_URL}/embedded/index/${selectedIndex}?height=${selectedHeight}&colors=${selectedColors}${selectedLegend}"
              style="border:none; width: 100%; height: ${selectedHeight};"
            />
          `}
          </code>
        </Grid>
      </Grid>
      <iframe
        src={`${DOMAIN_URL}/embedded/index/${selectedIndex}?height=${selectedHeight}&colors=${selectedColors}${selectedLegend}`}
        style={{ border: 'none', width: '100%', height: selectedHeight }}
      />
    </>
  );
};

export default Demo;
